import { render, staticRenderFns } from "./UpdateRegistrar.vue?vue&type=template&id=6376201d&"
import script from "./UpdateRegistrar.vue?vue&type=script&lang=js&"
export * from "./UpdateRegistrar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports